import { mapperModuleMedia } from '../../modules/mappers'

export const mapperBlockKnowledgeHubTopic = (data, imageSizes, knowledgeHubRoute, filterMappings) => {
  const image = mapperModuleMedia(data.image, { resize: true, sizes: imageSizes })
  const url = `${knowledgeHubRoute}?${filterMappings[data.topic.contentType]}=${data.topic.sys.id}`
  return {
    image: image?.medium || { src: '', alt: '' },
    imageWithSizes: image,
    name: data.topic.name,
    link: {
      title: data.topic.name,
      nuxt: true,
      openInNewWindow: false,
      url
    }
  }
}
